module.exports = __webpack_public_path__ + "static/media/Sec-1_2677HomePlayer_ID_Mobile.5a62b957.png";